import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PreAuthLayout from '€layouts/PreAuthLayout';
import MetaLayout from '€layouts/MetaLayout';
import {
    getResetTokenValidationState,
    getValidResetToken,
} from '€slices/password-reset/password-reset-selectors';
import PasswordResetForm from '€components/PasswordResetForm';
import PasswordResetInvalid from '€components/PasswordResetInvalid';
import { RequestState } from '~/src/types/RequestState';
import { validateResetPasswordToken } from '€slices/password-reset';

const ResetPassword = () => {
    const { token } = useParams<{ token?: string }>();
    const validToken = useSelector(getValidResetToken);
    const state = useSelector(getResetTokenValidationState);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(validateResetPasswordToken(token));
        // just needs to run once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <MetaLayout metaTitle="Loan | Reset Password">
            <PreAuthLayout title="Reset Password">
                {validToken != null && validToken === token && (
                    <PasswordResetForm token={validToken} />
                )}
                {validToken == null && state === RequestState.Error && <PasswordResetInvalid />}
            </PreAuthLayout>
        </MetaLayout>
    );
};

export default ResetPassword;
